var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 233,
    viewBox: "0 0 92 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.2237 232.557H0.088623V226.358H33.2237C44.0354 226.358 52.8315 217.579 52.8315 206.787V26.2124C52.8315 15.4211 44.0354 6.64161 33.2237 6.64161H0.218505V0.442871H33.2237C47.4591 0.442871 59.0419 12.0038 59.0419 26.2124V206.787C59.0419 220.996 47.4591 232.557 33.2237 232.557Z",
    fill: "#00A89D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M91.5363 116.534L71.3669 104.35V128.714L91.5363 116.534Z",
    fill: "#00A89D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M82.916 112.409H53.8374V120.658H82.916V112.409Z",
    fill: "#00A89D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4);
export default __webpack_public_path__ + "static/media/Group (4).f671a237c1c3db6c940448aa67424883.svg";
export { ForwardRef as ReactComponent };